<template>
  <b-modal
    no-close-on-backdrop
    header-bg-variant="orange"
    header-text-variant="light"
    centered
    size="xl"
    v-model="open"
    title="Detalhes do historico"
    :busy="loading"
    :hide-footer="true"
  >
    <b-card>
      <b-row>
        <b-col cols=12>
          <b-row>
            <b-col cols="12" style="background-color: #f2f2f2;" class="mb-2">
              <h4 class="text-center">Produto</h4>
            </b-col>
            <b-col cols="2">
              <p><strong>Foto do produto: </strong></p>
              <div>
                <b-img
                  :src="linkImage(fields.image)"
                  width="60"
                  height="50"
                  :alt="fields.image"
                ></b-img>
              </div>
            </b-col>
            <b-col>
              <p><strong>Produto: </strong></p>
              <p>{{ fields.name }}</p>
            </b-col>
            <b-col>
              <p><strong>Quantidade de prooduto: </strong></p>
              <p>{{ fields.quantity }}</p>
            </b-col>
            <b-col>
              <p><strong>Valor do produto: </strong></p>
              <p>{{ formatMoneyUn(fields.price) }}</p>
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="12" class="mt-4">
          <b-row>
            <b-col cols="12" style="background-color: #f2f2f2;" class="mb-2">
              <h4 class="text-center">Parceiro</h4>
            </b-col>
            <b-col cols="2">
              <p><strong>Id do parceiro: </strong></p>
              <p>{{ partner.partner_id }}</p>
            </b-col>
            <b-col>
              <p><strong>Nome do parceiro: </strong></p>
              <p>{{ partner.nome_fantasia }}</p>
            </b-col>
            <b-col>
              <p><strong>CNPJ: </strong></p>
              <p>{{ partner.cnpj }}</p>
            </b-col>
            <b-col>
              <p><strong>Email: </strong></p>
              <p>{{ partner.email }}</p>
            </b-col>
          </b-row>
        </b-col>
   
        <b-col cols="12" class="mt-4">
          <b-row>
            <b-col cols="12" style="background-color: #f2f2f2;" class="my-2">
              <h4 class="text-center">Pedidos (valores e taxas)</h4>
            </b-col>
            <b-col cols="2">
              <p><strong>Data da compra: </strong></p>
              <p>{{ orderData.createdAt }}</p>
            </b-col>
            <b-col>
              <p><strong>Id pedido: </strong></p>
              <p>{{ orderData.paymentId }}</p>
            </b-col>
            <b-col>
              <p><strong>Status: </strong></p>
              <p>{{ getStatus(orderData.status) }}</p>
            </b-col>
            <b-col>
              <p><strong>Lucro %: </strong></p>
              <p>{{ parseFloat(orderData.percentage) }}%</p>
            </b-col>
            <b-col>
              <p><strong>Lucro: </strong></p>
              <p>{{ formatMoneyUn(orderData.valueShopkeeper) }}</p>
            </b-col>
            <b-col>
              <p><strong>Valor parceiro: </strong></p>
              <p>{{ formatMoneyUn(orderData.valuePartner) }}</p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    
    <b-row class="d-flex justify-content-end mt-4">
      <b-button
        class="mr-3"
        @click="closeModal()"
        variant="danger"
      >
      Fechar
    </b-button>
    </b-row>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import makeToast from '@/mixins/makeToast';
import { formatMoney } from '@/utils/number';
import { mapLabel } from '@/enums/Partner/PaymentPartnerStatus';

export default {
  name: 'DetailPaymentPartnerModal',
  mixins: [makeToast],

  data() {
    return {
      loading: false,
      idPaymentPartner: null,
      idShopkeeper: null,
      partner: [],
      orderData: [],
      fields: [],
      open: false,
    };
  },
  methods: {
    ...mapActions('shopkeeper', ['getOrderDetails']),

    toggleOpen({ 
      idPaymentPartner = null, 
      idShopkeeper = null, 
      partner = [],
      orderData = []
    }){
      this.open = !this.open;
      this.idPaymentPartner = idPaymentPartner;
      this.idShopkeeper = idShopkeeper;
      this.partner = partner;
      this.orderData = orderData;
      this.get();
    },

    isIdPartner(id){
      if(this.productsPartners.length == 0) return
      
      const result = this.productsPartners.map((item) => {
        if(item.product_id == id && item.partner_user_id == this.idPartner) return true;
      });

      return result.includes(true);
    },
 
    get() {
      if (this.loading) return;
      this.loading = true;
      this.$store.dispatch('startLoader');

      const data = {
        orderId: this.orderData.paymentId,
        userId: this.idShopkeeper,
        shopkeepersIds: [],
      }
      this.getOrderDetails(data)
      .then((response) => {
          const result = response.data.data || {};
          this.fields = result.products.find(item => item.sku == this.orderData.productId);
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer os dados do pedido',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
          this.$store.dispatch('endLoader');
        });
    },
    
    linkFotos(origem) {
      if(origem == 'Belenus' || origem == 'fixadores') {
        return 'https://storage.googleapis.com/fotos-prd/';
      } else {
        return process.env.VUE_APP_FOTOS_URL;
      }
    },

    formatNumber(number) {
      return Intl.NumberFormat('pt-BR', {
        currency: 'BRL',
        style: 'currency',
      }).format(number);
    },

    closeModal(){
      this.open = !this.open;
    },
    
    getNamePartner(id) {
      const partner = this.partners.find((partner) => partner.partner_id == id);
      return partner ? partner.nome_fantasia : '';
    },

    formatMoneyUn(value) {
      return formatMoney(value);
    },

    getStatus(status) {
      return mapLabel(status);
    },

    linkImage(value) {
      return process.env.VUE_APP_FOTOS_URL + value;
    },
  },
};
</script>
